module.exports = __webpack_public_path__ + "img/row-right-dark.b5f312f7.svg";